import { IconArrowUpRight } from '@tabler/icons-react';
import { Center, Group, Paper, RingProgress, Text } from '@mantine/core';

type PerformanceStatProps = {
  label: string;
  value: number;
};

export const PerformanceStat = ({ label, value }: PerformanceStatProps) => {
  return (
    <Paper withBorder radius="md" p="xs">
      <Group gap="lg">
        <RingProgress
          size={60}
          roundCaps
          thickness={8}
          sections={[{ value, color: '#12B886' }]}
          label={
            <Center>
              <IconArrowUpRight size={24} stroke={1.5} />
            </Center>
          }
        />

        <div>
          <Text c="dimmed" size="xs" tt="uppercase" fw={700}>
            {label}
          </Text>
          <Text fw={700} size="xl">
            {`${value}%`}
          </Text>
        </div>
      </Group>
    </Paper>
  );
};
